export default __webpack_public_path__ + "aa40626a88d8b5fb5a2068d15e492ba8.png";